<div class="modal-header">
  <h4 class="modal-title fw-normal">Upload File(s)</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>

<div class="modal-body">
  @if (uploading()) {
  <groundworks-state-message type="loading" message="Retrying upload..." class="d-flex" />
  } @else { @if (uploadError()) {
  <div class="alert alert-danger" role="alert">
    {{ uploadError() }}
  </div>
  }

  <div class="alert alert-danger border-danger" role="alert">
    <div class="d-flex align-items-center mb-2">
      <i class="bi bi-check-circle-fill text-danger me-2"></i>
      <span>The following file(s) were not uploaded. Cancel upload or try again.</span>
    </div>
  </div>
  <div class="failed-files-list">
    @for (file of failedFiles; track file.name) {
    <div class="d-flex align-items-center p-2 border rounded bg-light">
      @if (file.type.startsWith('image/')) {
      <img [src]="getFilePreviewUrl(file)" alt="Preview" class="file-thumb me-2" />
      } @else {
      <div
        class="file-icon me-2 d-flex align-items-center justify-content-center bg-secondary text-white rounded"
      >
        <i class="bi bi-file-earmark"></i>
      </div>
      }
      <span class="flex-grow-1">{{ file.name }}</span>
      <button
        type="button"
        class="btn btn-sm btn-link text-muted p-0"
        (click)="onRemoveFile(file)"
        aria-label="Remove file"
      >
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    }
  </div>
  }
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" type="button" (click)="onCancel()" [disabled]="uploading()">
    Cancel
  </button>
  <button
    class="btn btn-primary"
    type="button"
    (click)="onRetry()"
    [disabled]="uploading() || failedFiles.length === 0"
  >
    @if (uploading()) {
    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    Uploading... } @else { Try Again }
  </button>
</div>
